import React, {Component} from 'react';
import {connect} from 'react-redux';
import Nav from './components/nav/';
import Loading_Text from './components/loading_text/';
import utils from './utils/config.js';
import {
  welcome,
  blooddrive,impact,dam,reclaimed,lift,harbor,foundation,diner,forge,theslab,oldtown,
  inferno,train,mirage,nuke,cobblestone,overpass,cache,
  promenade,redfalls,reactor,station,trench,vertigo,grandview,mammoth,
  soccer,football,basketball,baseball,hockey,
  bank1,bank2,bank3,bank4,clubhouse1,clubhouse2,clubhouse3,clubhouse4,
  asylum,bunker,district,exhibit,icebound,traininggrounds,vasgar,
  bind,haven,split, ascent,
  canals, favelas, skyfell, windward, icarus, vice, highcastle, factory
} from './utils/maps/image_paths.jsx';

var App = React.createClass({
  getInitialState: function() {

              return {
                  isLoading:'true',
              }
      },
     componentDidMount() { this.setState ({isLoading: false})},

render() {

var data = {
  TRICKSTRATWELCOME: welcome,
  GEARS4IMPACT: impact,GEARS4BLOODDRIVE: blooddrive,GEARS4DAM: dam,GEARS4RECLAIMED: reclaimed,GEARS4LIFT: lift,GEARS4HARBOR: harbor,GEARS4FOUNDATION: foundation,GEARS4DINER: diner,GEARS4FORGE: forge,GEARS4THESLAB: theslab, GEARS4OLDTOWN: oldtown,
  CSGOINFERNO: inferno,CSGOTRAIN: train,CSGOMIRAGE: mirage,CSGONUKE: nuke,CSGOCOBBLESTONE: cobblestone,CSGOOVERPASS: overpass,CSGOCACHE: cache,
  LAWBREAKERSPROMENADE: promenade, LAWBREAKERSREDFALLS: redfalls, LAWBREAKERSREACTOR: reactor, LAWBREAKERSSTATION: station, LAWBREAKERSTRENCH: trench, LAWBREAKERSVERTIGO: vertigo, LAWBREAKERSGRANDVIEW: grandview, LAWBREAKERSMAMMOTH: mammoth,
  SPORTSSOCCER: soccer,SPORTSFOOTBALL: football,SPORTSBASKETBALL: basketball,SPORTSBASEBALL: baseball,SPORTSHOCKEY: hockey,
  RS6BANK1: bank1,RS6BANK2: bank2,RS6BANK3: bank3,RS6BANK4: bank4,RS6CLUBHOUSE1: clubhouse1,RS6CLUBHOUSE2: clubhouse2,RS6CLUBHOUSE3: clubhouse3,RS6CLUBHOUSE4: clubhouse4,
  GEARS5ASYLUM: asylum, GEARS5BUNKER: bunker, GEARS5DAM: dam, GEARS5DISTRICT: district, GEARS5EXHIBIT: exhibit, GEARS5FORGE: forge,GEARS5FOUNDATION: foundation,GEARS5HARBOR: harbor, GEARS5TRAININGGROUNDS: traininggrounds,GEARS5ICEBOUND: icebound,GEARS5RECLAIMED: reclaimed, GEARS5VASGAR: vasgar,
  VALORANTBIND: bind, VALORANTHAVEN: haven, VALORANTSPLIT: split, VALORANTASCENT: ascent,
  ROGUECOMPANYCANALS: canals, ROGUECOMPANYFAVELAS: favelas, ROGUECOMPANYSKYFELL: skyfell, ROGUECOMPANYWINDWARD: windward, ROGUECOMPANYICARUS: icarus, ROGUECOMPANYVICE: vice, ROGUECOMPANYHIGHCASTLE: highcastle, ROGUECOMPANYFACTORY: factory
};

      //console.log(this.props);
      var {map, overlay,currentUser, active, userData} = this.props;
      var bg = null;
      var strat = null;
      if (map != null) {
        //bg = './images/' + map.game + '/' + map.map + '.jpg';
        bg = data[map.game+map.map];
      }
        //console.log(src);
        //var strat     = document.createElement('img'); // create a Image Element
        //strat.src     = src;   //image source


     var divStyle = {
        //backgroundImage: 'url(' + bg + ')',
        //backgroundSize: '100% auto',
        //backgroundRepeat: 'no-repeat',
        //maxWidth: '80%',
        marginTop:'-45'
      }

    /*  var stratStyle = {
        backgroundImage: 'url(' + strat + ')',
        backgroundSize: '100% auto',
        backgroundRepeat: 'no-repeat',

      }*/

      var appName = utils.getAppName();
      var subTitle = utils.getSubTitle();
      var twitter = utils.getTwitter();
      var displayName =  '';

      if (currentUser && currentUser.uid && currentUser.emailVerified){
      displayName =  currentUser.displayName;
      }

      return (  this.state.isLoading? <div><Loading_Text /></div> :
        <div className="contentStyle">
          <Nav/>
              <div id="target" className="container" style={divStyle}>
              {/*<div id="stratDiv"  className="container"  style={stratStyle}>*/}

              {/*}<div className="watermarkLeft">
               <b>{appName}</b><br/>
               {subTitle}
              </div>
              <div className="watermarkRight">
               <b>{getGameTitle(map.game)} | {getMapTitle(map.map)}</b>
               <br/>
              {displayName}
               </div>*/}

            {this.props.children}
          </div>


        </div>
      );
    }
  });

  module.exports = connect((state) => {
    return {currentUser: state.currentUser, map: state.map, overlay: state.overlay, modal: state.modal, userData: state.userData,  active: state.active}
  })(App);



// WEBPACK FOOTER //
// ./src/app/app.jsx